/**
 * True once the page is being left (navigation, reload, tab closed). The browser then cancels
 * requests still in flight; those failures are not "API unreachable" and must not be reported
 * as WEB-API-001 (found in the Phase 10 deployment rehearsal).
 */
let leaving = false;

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => {
    leaving = true;
  });
  // A page restored from the back/forward cache is live again.
  window.addEventListener('pageshow', () => {
    leaving = false;
  });
}

export const pageIsLeaving = () => leaving;
